/**
 * App.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import $ from 'jquery';
import ScrollUpButton from "react-scroll-up-button";
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline';

//Assets
import 'font-awesome/css/font-awesome.css';
import '../static/css/buhobank.css';
import '../static/css/material-icons.css';
import '../static/css/roboto.css';

//Components
import Content from './Global/Content';
import Footer from './Global/Footer';

class App extends Component {
  //constructor
  constructor() {
    super();

    this.state = {
      style: {
        backgroundColor: 'white',
      }
    }
  }

  static propTypes = {
    children: PropTypes.object.isRequired
  };

  //jquery
  componentDidMount() {
    window.onload = function () {
      $(".load").fadeOut(700);
      const script = document.createElement("script");
      script.src = "https://af661eb2-pm-assets-cdn.s3.amazonaws.com/resource-786573.2430113634.js";
      script.async = true;
      document.head.appendChild(script);
    }
    
    $("#mainContent").fadeIn( function() {
        $(".loadScheduler").fadeOut(700);
    });
  }

  render() {
    const { children } = this.props;
    return (
      <div className="App">
        <CssBaseline>
          <div className="load">
            <ReactLoading type='spin' delay={1} color="#f47321" className="loading" />
          </div>
          <div className="loadScheduler">
            <ReactLoading type='spin' delay={1} color="#f47321" className="loading" />
          </div>
          <main id="mainContent">
            <Content body={children} />
          </main>
          <Footer />
          <ScrollUpButton />
        </CssBaseline>
      </div >
    );
  }
}

const mapStateToProps = function (state) {
  return {
    estado: state,
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js